import {DependencyInjectId} from "@@/package/const/DependencyInjectId";
import HttpClient from "@@/package/network/HttpClient";
import {type AxiosResponse} from "axios";
import {type ApplicationContextInterface} from "@@/package/application/applicationContext";
import {ContestListModel} from "~~/package/mapper/contest/model/ContestListModel";
import {ContestLeaderBoardModel} from "~~/package/mapper/contest/model/ContestLeaderBoardModel";
// @ts-ignore
import type ContestResponse from "~~/package/apis/contest/response/ContestResponse";
import {PageModel} from "~~/package/mapper/common/model/PageModel";
import {ContestLeaderBoardExistsModel} from "~~/package/mapper/contest/model/ContestLeaderBoardExistsModel";
import type ContestRequest from "~~/package/apis/contest/response/ContestRequest";
import {CautionType} from "~~/package/types/CautionType";
import type CustomResponse from "~~/package/types/ResponseType";
import type {LearningTokenData} from "~~/package/mapper/learning/model/LearningTokenData";

export default class ContestApi {

  protected http: HttpClient;

  constructor(context: ApplicationContextInterface) {
    this.http = context.getService<HttpClient>(DependencyInjectId.HttpClient);
  }

  public getContestList(Lang: string): Promise<AxiosResponse<CustomResponse<ContestListModel[]>>> {
    return this.http.get<AxiosResponse<CustomResponse<ContestListModel[]>>>("/contest/list", undefined, true, Lang);
  }

  public getContestDetail(id: number, Lang: string): Promise<AxiosResponse<CustomResponse<ContestListModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<ContestListModel>>>(`/contest/${id}`, undefined, true, Lang);
  }

  public getContestLeaderBoard(id: number, page: number, itemSize: number): Promise<AxiosResponse<CustomResponse<PageModel<ContestLeaderBoardModel>>>> {
    return this.http.get<AxiosResponse<CustomResponse<PageModel<ContestLeaderBoardModel>>>>(`/contest/${id}/leaderBoard`, { page, itemSize }, true);
  }

  public getContestMyLeaderBoard(id: number): Promise<AxiosResponse<CustomResponse<ContestLeaderBoardModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<ContestLeaderBoardModel>>>(`/contest/${id}/myLeaderBoard`, undefined, true);
  }

  public getContestAdminGrading(id: number): Promise<AxiosResponse<CustomResponse<ContestLeaderBoardExistsModel>>> {
    return this.http.get<AxiosResponse<CustomResponse<ContestLeaderBoardExistsModel>>>(`/contest/${id}/adminGrading/exists`, undefined, true);
  }

  public getContestAuthentication(id: number, code: string): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.get<AxiosResponse<CustomResponse<boolean>>>(`/contest/${id}/authentication`, { code }, true);
  }

  public getContestReceive(contestId: number, termsId: number): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.post<AxiosResponse<CustomResponse<boolean>>, { [key: string]: number }>(`/contest/receive`, { contestId, termsId }, true);
  }

  public getContestData(contestId: number, lang?: string): Promise<AxiosResponse<CustomResponse<ContestResponse>>> {
    return this.http.get<AxiosResponse<CustomResponse<ContestResponse>>>(`/contest/${contestId}/question`, {}, true, lang);
  }

  public setCurrentContestTask(id: number, taskId: number): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.put<AxiosResponse<CustomResponse<boolean>>, {[key: string]: number}>(`/contest/lastClick`, {id, taskId}, true);
  }

  public submitAnswer(contestRequest: ContestRequest, tokenData: LearningTokenData): Promise<AxiosResponse<CustomResponse<boolean>>> {
    return this.http.post<AxiosResponse<CustomResponse<boolean>>, ContestRequest>(
        "/v2.2/contests/code/submission",
        contestRequest,
        true,
        null,
        false,
        {hmac: tokenData.hmac, issued_at: tokenData.issuedAt}
    );
  }

  public setContestUserAction(contestId: number, suspiciousAction: CautionType, actionContent?: string): Promise<AxiosResponse<CustomResponse<number>>> {
    return this.http.post<AxiosResponse<CustomResponse<number>>, { [key: string]: string | undefined }>(`/contest/${contestId}/my/action`, { suspiciousAction, actionContent }, true);
  }
}
